import React, { cloneElement } from 'react';
import { classNames } from '../../utils/style';
import { textBodyUppercaseSmall, textCaption } from '../../styles/typography';
import { Image } from '../../components/Image';

import {
  applyCardContentStyle,
  applyCardStyle,
  applyCtaButtonStyle,
  applyLogoContentStyle,
  applyQuoteWithImgStyle,
  applyTextStyle,
} from './logic';
import { CardProps } from '.';

export const ArticleCard = ({
  children,
  cardsBackgroundColor,
  disableBorder,
  imagePosition,
  type,
  className,
  capsText,
  logo,
  companyDescription,
  text,
  ctaButton,
  as: Component = 'article',
}: CardProps) => {
  const newCta =
    ctaButton &&
    cloneElement(ctaButton, {
      className: applyCtaButtonStyle(type),
    } as React.HTMLAttributes<HTMLElement>);
  return (
    <Component
      className={classNames(
        'Card ArticleCard',
        'rounded-18 flex gap-24',
        !disableBorder && 'border-2 border-neutral-51',
        type === 'quoteWithImg'
          ? applyQuoteWithImgStyle(imagePosition, cardsBackgroundColor || false)
          : applyCardStyle(type),
        className,
      )}
    >
      <div className={applyCardContentStyle(type)}>
        {capsText && (
          <span
            className={classNames(
              'text-neutral-101 mb-24',
              textBodyUppercaseSmall,
            )}
          >
            {capsText}
          </span>
        )}
        {logo && (
          <div className={`${applyLogoContentStyle(type)}`}>
            <Image {...logo} className="w-auto h-full" />
          </div>
        )}

        {text && <p className={applyTextStyle(type)}>{text}</p>}

        {companyDescription && (
          <div
            className={classNames(
              'text-neutral-101 hidden md:block',
              textCaption,
            )}
          >
            {companyDescription}
          </div>
        )}
        {children}
        {newCta && newCta}
      </div>
    </Component>
  );
};
export default ArticleCard;
